export function assetUrl(path) {
  if (!path) return "/svg/img_placeholder.svg";

  if (path.startsWith("http://") || path.startsWith("https://")) {
    try {
      const url = new URL(path);
      if (url.pathname.startsWith("/front-end/")) {
        return `${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      return path;
    }
    return path;
  }

  return path.startsWith("/") ? path : `/${path}`;
}

export function productImage(product, size = "medium") {
  const images = product?.images || [];
  const image = images.find((item) => item.is_cover) || images[0];
  if (!image) return assetUrl(null);
  const preferred = {
    small: image.thumbnail_small,
    medium: image.thumbnail_medium || image.thumbnail_large,
    large: image.thumbnail_large || image.image,
    original: image.image,
  };
  return assetUrl(preferred[size] || image.image);
}
